module.exports = __webpack_public_path__ + "img/favicon.c43d1a8f.png";